'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpeningHours = undefined;
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _react = require('react');
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var fetchOpeningHours = function fetchOpeningHours() {
  return _axios2.default.get(process.env.REACT_APP_API_BASE_URI + '/shared/v1/public/marmalade-contact/open-text');
};
var useOpeningHours = exports.useOpeningHours = function useOpeningHours() {
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  (0, _react.useEffect)(function () {
    fetchOpeningHours().then(function (response) {
      return setMessage(response.data.data.openText);
    }, function () {
      return setMessage('');
    });
  }, []);
  return {
    message: message,
    isOpen: message.toLowerCase().includes('until')
  };
};